import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';
import { useGoogle360 } from '../utils/google360';

const API = getApiUrl();

export const LoginPage = () => {
  const google = useGoogle360();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { tenantSlug } = useParams();
  const slug = tenantSlug || 'avocado';
  const [useDemo, setUseDemo] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/auth/callback';
    void redirectUrl;  // LOT 47 · 2.3 · plus de lien Google d’Emergent (connexion Google 360 à venir)
  };
  
  const handleDemoLogin = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/demo-login`, {
        email: `demo@${slug}.demo`,
        name: 'Demo User',
        role: 'owner',
        tenant_slug: slug
      }, { withCredentials: true });
      
      // Set user in auth context so ProtectedRoute works
      setUser(response.data.user);
      navigate(`/${slug}/dashboard`, { replace: true });
    } catch (error) {
      alert(error?.response?.data?.detail || 'Erreur de connexion démo');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--carte)] flex items-center justify-center p-4">
      <motion.div 
        className="max-w-sm w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="text-7xl mb-4"></div>
          <h1 className="text-3xl font-bold text-[var(--texte)]" style={{ fontFamily: "'Inter', sans-serif" }}>
            360 Resto
          </h1>
          <p className="text-[var(--texte-2)] text-sm mt-2">Plateforme de gestion restaurant</p>
        </div>

        {/* Login Card */}
        <div className="bg-[var(--carte)] rounded-2xl p-6 border border-[var(--bord)]">
          <h2 className="text-xl font-semibold text-[var(--texte)] mb-6 text-center">
            Connexion
          </h2>
          
          {!useDemo ? (
            <>
              {google && <button
                onClick={handleGoogleLogin}
                data-testid="google-login-button"
                className="w-full bg-[var(--brand)] text-[var(--sur-couleur)] rounded-xl py-3.5 px-6 font-medium flex items-center justify-center gap-3 transition-all active:scale-[0.98] hover:bg-[var(--brand-hover)]"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z"/>
                </svg>
                Continuer avec Google
              </button>}

              <div className="mt-4 text-center">
                <button
                  onClick={() => setUseDemo(true)}
                  className="text-[var(--brand)] text-sm font-medium hover:underline"
                >
                  Problème de connexion ? Mode démo
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="mb-4 p-3 bg-[var(--brand)]/10 border border-[var(--brand)]/20 rounded-xl">
                <p className="text-[var(--brand)] text-sm text-center font-medium">
                  Mode démo - Connexion sans Google
                </p>
              </div>
              
              <button
                onClick={handleDemoLogin}
                disabled={loading}
                data-testid="demo-login-button"
                className="w-full bg-[var(--brand)] text-[var(--sur-couleur)] rounded-xl py-3.5 px-6 font-medium transition-all active:scale-[0.98] hover:bg-[var(--p-3d6422)] disabled:opacity-50"
              >
                {loading ? 'Connexion...' : 'Accéder en mode démo'}
              </button>

              <div className="mt-4 text-center">
                <button
                  onClick={() => setUseDemo(false)}
                  className="text-[var(--texte-2)] text-sm hover:underline"
                >
                  Retour à Google Auth
                </button>
              </div>
            </>
          )}
        </div>

        <p className="mt-6 text-center text-xs text-[var(--texte-2)]">
          29 Boulevard Carnot, 59800 Lille<br/>
          7j/7 • 10h-22h non stop
        </p>
      </motion.div>
    </div>
  );
};
